<template lang="pug">
    .byregion

        .byregion__inner

            h3.byregion__title
                span(v-html="title")

            .byregion-region
                .byregion-region__inner
                    select.byregion-region__select(
                        v-model='selectedRegion'
                        )
                        option(
                            disabled='disabled'
                            ) Выберите регион
                        option(
                            v-for='(regionValue, regionKey) in regionsData',
                            :key='regionKey'
                            ) {{regionKey}}
                    svg.byregion-region__svg(
                        xmlns='http://www.w3.org/2000/svg',
                        viewBox='0 0 93.36 66.32',
                        width='93',
                        height='66',
                        aria-label='Выбрать регион'
                        )
                        path(d='M93.36 0L60.44 66.32H32.92L0 0h19.88l26.56 56.46L73.48 0z')

            ul.byregion-legend(
                v-if='regionData.length > 0'
                )

                li.byregion-legend__item(
                    v-for='(legendValue, legendKey) in legend',
                    :key='legendKey',
                    :data-type='legendKey'
                    ) {{legendValue}}

            .byregion-data(
                v-if='regionData.length > 0'
                )

                .byregion-data__item(
                    v-for='regionItem in regionData',
                    :key='regionItem.name'
                    )

                    h4.byregion-data__title {{regionItem.name}}

                    .byregion-data__indicators

                        .byregion-data__indicator(
                            data-type='mass',
                            :aria-label='legend.mass'
                            )
                            span.byregion-data__bar(
                                data-type='mass',
                                :style='"width:" + regionItem.massPercent + "%"'
                                )
                                span.byregion-data__value(
                                    :data-full='regionItem.massPercent > 90 ? true : false'
                                    ) {{regionItem.mass}}

                        .byregion-data__indicator(
                            data-type='value',
                            :aria-label='legend.value'
                            )
                            span.byregion-data__bar(
                                data-type='value',
                                :style='"width:" + regionItem.valuePercent + "%"'
                                )
                                span.byregion-data__value(
                                    :data-full='regionItem.valuePercent > 90 ? true : false'
                                    ) {{regionItem.value}}

                        .byregion-data__indicator(
                            data-type='offers',
                            :aria-label='legend.offers'
                            )
                            span.byregion-data__bar(
                                data-type='offers',
                                :style='"width:" + regionItem.offersPercent + "%"'
                                )
                                span.byregion-data__value(
                                    :data-full='regionItem.offersPercent > 90 ? true : false'
                                    ) {{regionItem.offers}}

        .byregion__share(v-if="share")
            share(:url="share.shareUrl", :title="share.title", :description="share.description")

</template>

<script>
import Share from '@/components/Share.vue';

const isProd = process.env.NODE_ENV === 'production';
const meta = require('@/assets/data/meta.json');
const projectPath = meta.url.indexOf('https://dyn.ig.rambler.ru') !== -1 ? meta.url.replace('https://dyn.ig.rambler.ru', '') : '/';
const publicPath = isProd ? projectPath : '/';

export default {
    name: 'ByRegion',

    props: {
        title: {
            type: String,
            required: true
        },
        share: {
            type: Object,
            default: null
        }
    },

    components: {
        Share
    },

    data() {
        return {
            regionsData: {},
            regionData: [],
            errors: [],
            selectedRegion: 'Выберите регион',
            legend: {
                mass: 'Масса, кг',
                value: 'Стоимость, руб.',
                offers: 'Количество предложений в день'
            }
        };
    },

    computed: {
        maxValues() {
            const regionsValues = Object.values(this.regionsData);
            const regionsArray = [].concat(...regionsValues);

            const result = {};

            regionsArray.forEach(({name, value, mass, offers}) => {
                if (result.hasOwnProperty(name)) {
                    result[name].value = value > result[name].value ? value : result[name].value;
                    result[name].mass = mass > result[name].mass ? mass : result[name].mass;
                    result[name].offers = offers > result[name].offers ? offers : result[name].offers;
                } else {
                    result[name] = {
                        value,
                        mass,
                        offers
                    };
                }
            });

            return result;
        }
    },

    watch: {
        selectedRegion(value) {
            if (value === 'Выберите регион') {
                return [];
            } else {
                const selectedData = this.regionsData[value];

                this.regionData = selectedData.reduce((accumulator, {name, value, mass, offers}) => {
                    const roundNumber = number => {
                        return (Math.round(number * 1000) / 1000).toLocaleString('ru-RU');
                    };

                    accumulator.push({
                        name,
                        value: roundNumber(value),
                        valuePercent: this.calcPercentage({value: value, name, type: 'value'}),
                        mass: roundNumber(mass),
                        massPercent: this.calcPercentage({value: mass, name, type: 'mass'}),
                        offers: roundNumber(offers),
                        offersPercent: this.calcPercentage({value: offers, name, type: 'offers'})
                    });
                    return accumulator;
                }, []);
            }
        }
    },

    async created() {
        try {
            const response = await fetch(publicPath + 'assets/data/byregion.json');

            this.regionsData = await response.json();
        } catch (e) {
            this.errors.push(e);
        }
    },

    beforeDestroy() {
        this.regionsData = {};
        this.regionData = [];
        this.errors = [];
        this.selectedRegion = 'Выберите регион';
    },

    methods: {
        calcPercentage({value, name, type}) {
            const maxValue = this.maxValues[name][type];
            const percent = (100 * value) / maxValue;
            return Math.round(percent * 1000) / 1000;
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars';

@keyframes scaleX {
    from {
        transform: scaleX(0);
    }
    to {
        transform: scaleX(1);
    }
}

@keyframes opacityTransformX {
    from {
        opacity: 0;
        transform: translateX(-15px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.byregion {
    width: calc(75% + var(--scr-padding-side) * 4);
    margin: 0 auto var(--width-column-grid);
    padding: calc(var(--scr-padding-side) * 2);
    border: 1px solid var(--color-accent);
    background-color: var(--color-outline-bg);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        width: 100%;
        margin-bottom: 2rem;
        padding: calc(var(--scr-padding-side) * 2) var(--scr-padding-side);
    }

    &__inner {
        display: flex;
        flex-wrap: wrap;
        margin: 0;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            flex-wrap: nowrap;
            flex-direction: column;
        }
    }

    &__share {
        color: var(--color-header);
        display: flex;
        justify-content: center;
        padding-top: 1em;

        .share__item {
            transform: translateY(30%);
        }
    }

    &__title {
        display: flex;
        justify-content: flex-end;
        width: 50%;
        margin: 0 auto;
        padding: 0 1em 0 0;
        font-family: var(--font-accent);

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            justify-content: center;
            width: 100%;
            margin-bottom: 1em;
            padding: 0;
        }

        span {
            padding: 0.5em;
            background-color: rgba(#01fff0, 0.15);
            color: var(--color-accent);
            text-align: center;
        }
    }

    &-region {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 50%;
        margin: 0 auto;
        padding: 0 0 0 1em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            justify-content: center;
            width: 100%;
            padding: 0;
        }

        &__inner {
            position: relative;
        }

        &__select {
            position: relative;
            display: block;
            appearance: none;
            max-width: 100%;
            height: 2.6em;
            padding-bottom: calc(0.375em - 1px);
            padding-left: calc(0.625em - 1px);
            padding-right: calc(0.625em - 1px);
            padding-top: calc(0.375em - 1px);
            border: 1px solid;
            border-radius: 0;
            outline: 0;
            box-shadow: none;
            font-size: 1em;
            font-family: var(--font-accent);
            line-height: 1.5;
            background-color: inherit;
            color: var(--color-accent-strong);
            cursor: pointer;

            &:focus-visible {
                color: var(--color-main-text);

                & ~ svg {
                    fill: var(--color-main-text);
                }
            }
        }

        &__svg {
            position: absolute;
            top: 50%;
            right: 1em;
            transform: translateY(-50%);
            width: 1.25em;
            height: auto;
            fill: var(--color-accent-strong);
            pointer-events: none;
        }
    }

    &-legend {
        width: 100%;
        margin: 2em 0;
        font-family: var(--font-accent);

        &__item {
            position: relative;
            margin: 0;
            padding: 0 0 0 6em;
            line-height: 1.1;

            &:not(:last-child) {
                margin-bottom: 0.5em;
            }

            &::before {
                content: '';
                position: absolute;
                top: 0.2em;
                left: 0;
                width: 5em;
                height: 0.7em;
                margin: 0;
                background: currentColor;
            }

            &[data-type='value'] {
                color: var(--color-accent-diagram);
            }

            &[data-type='mass'] {
                color: var(--color-accent-strong);
            }

            &[data-type='offers'] {
                color: var(--color-accent);
            }
        }
    }

    &-data {
        width: 100%;
        margin: 0;

        &__item {
            margin: 0;

            &:not(:last-child) {
                margin-bottom: 1em;
            }
        }

        &__title {
            margin: 0 0 0.25em;
        }

        &__indicators {
            margin: 0;
            font-family: var(--font-accent);
            line-height: 1;
        }

        &__indicator {
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 0 0 0.5em;
            background: rgba(101, 179, 248, 0.15);

            &[data-type='value'] {
                color: var(--color-accent-diagram);
            }

            &[data-type='mass'] {
                color: var(--color-accent-strong);
            }

            &[data-type='offers'] {
                color: var(--color-accent);
            }
        }

        &__bar {
            position: relative;
            transition: width 0.4s ease;
            height: 1em;
            min-width: 0.1em;
            margin: 0;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                transform: scaleX(0);
                transform-origin: top left;
                width: 100%;
                height: 100%;
                animation: scaleX 0.6s ease forwards;
            }

            &[data-type='value'] {
                &::before {
                    background: var(--color-accent-diagram);
                }
            }

            &[data-type='mass'] {
                &::before {
                    background: var(--color-accent-strong);
                }
            }

            &[data-type='offers'] {
                &::before {
                    background: var(--color-accent);
                }
            }
        }

        &__value {
            position: absolute;
            top: 0;
            left: 100%;
            transform: translateX(-15px);
            animation: opacityTransformX 0.9s ease forwards;
            margin: 0 0 0 1em;
            opacity: 0;

            &[data-full] {
                left: auto;
                right: 0.5em;
                margin-left: 0;
                color: var(--color-outline-bg);
            }
        }
    }
}
</style>
